const index = () => import('./Index');

//2021年国家级专精特新“小巨人”企业研发经费投入补助资金
export default {
  routes: [
    {
      path: '/smes/service/v2022/index',
      name: 'smes_service_2022_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/smes/service/v2022/router.js